import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Chart from "react-apexcharts";
import Select from "react-select";
import Plot from "react-plotly.js";
import { cloneDeep, inRange } from "lodash";

const Visual = () => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [fcolumn, setfColumn] = useState("lfcSE");
  const [foperation, setfoperation] = useState(null);
  const [fvalue, setfvalue] = useState(null);
  const [filterState, setFilterState] = useState({
    column: "lfcSE",
    operation: ">",
    value: "0",
  });
  const [filters, setFilters] = useState([]);
  const [operations, setOperations] = useState([
    { name: "(==) equal to", op: "===" },
    { name: "(!=) not equal to", op: "!==" },
    { name: "(>) greater than", op: ">" },
    { name: "(>=) greater than or equal to", op: ">=" },
    { name: "(<) less than", op: "<" },
    { name: "(<=) less than or equal to", op: "<=" },
  ]);
  const [filteredItems, setFilteredItems] = useState(null);

  const [popupOpen, setPopupOpen] = useState(false);

  const [selectGene, setSelectGene] = useState([]);
  const [chartType, setChartType] = useState("scatter");

  // const filteredItems = data;

  // useEffect(() => {
  //   console.log("SHYYY")
  //   let fi = cloneDeep(data)
  //   filters.forEach(f => {
  //     fi.filter((item, i) => {
  //       return eval()
  //     });
  //   });
  //   setFilteredItems(fi);
  // }, [filters, data]);

  useEffect(() => {
    if (data.length === 0) {
      fetch(
        "https://firebasestorage.googleapis.com/v0/b/skygenic1.appspot.com/o/sk_full_result.txt?alt=media&token=2b90c207-dff6-4247-ad73-e8bd65a1a235"
      )
        .then((response) => response.text())
        .then((data) => {
          // Do something with your data
          const result = data.split("\n").map((s) => s.split(","));
          const cols = result[0].map((x, i) => {
            return {
              name: x,
              selector: (row) => row[i],
              sortable: true,
            };
          });
          setColumns(cols);
          console.log("mangoo");
          setData(result.slice(1));
          setAllData(result.slice(1).splice(1,5000))
          setFilteredItems(result.slice(1).filter((x, i) => i < 5000));
          // console.log(result.slice(1));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  const onchangeSelect = (item) => {
    console.log(item);
    let genes
    if(item !== null){
      genes = [...selectGene, item.pop()]
    } else {
      genes = []
    }

    let fi = cloneDeep(allData);
    let gg = fi.filter((item, i) => {
      console.log(item[1], genes)
      return genes.includes(item[1]);
    });
    setFilteredItems(gg);

    setSelectGene(genes)

    if(genes.length < 1){
      setFilteredItems(allData.slice(0,5000));
    }
  };

  const handleAddFilter = () => {
    setPopupOpen(false);
    setFilters((x) => [
      ...x,
      {
        fcolumn,
        foperation,
        fvalue,
        name: `${fcolumn}  ${foperation}  ${fvalue}`,
      },
    ]);

    let g = filteredItems.filter((item) => {
      let col_index;
      columns.forEach((c, i) => {
        if (c.name === fcolumn) {
          col_index = i;
          return;
        }
      });
      console.log(col_index, columns, fcolumn);
      console.log(`"${item[col_index]}" ${foperation} "${fvalue}"`);
      try {
        return eval(`"${item[col_index]}" ${foperation} "${fvalue}"`);
      } catch (e) {
        console.log(e);
      }
    });
    console.log(g);
    setFilteredItems(g);
  };

  const handleRemoveItem = (idx) => {
    // assigning the list to temp variable
    const temp = [...filters];
    setFilteredItems()
    // removing the element using splice
    temp.splice(idx, 1);

    // updating the list
    setFilters(temp);

    setFilteredItems(allData.slice(0, 5000));
  };

  const onScatterSelect = (e) => {
    let x_range = e.range.x;
    let y_range = e.range.y;

    console.log("SHYYY");
    let fi = cloneDeep(filteredItems);
    let gg = fi.filter((item, i) => {
      console.log(item[3], x_range[0], x_range[1]);
      console.log(item[4], x_range[0], x_range[1]);
      return (
        inRange(item[3], x_range[0], x_range[1]) &&
        inRange(item[4], y_range[0], y_range[1])
      );
    });
    console.log(gg);
    setFilteredItems(gg);
  };

  return (
    <>
      <div className="div-block-53">
        <div className="div-block-54">
          <div className="div-block-55" onClick={() => setPopupOpen((x) => !x)}>
            Add Filter{" "}
          </div>
          <div className="div-block-56">
            {filters.map((f, i) => {
              return (
                <div
                  className="div-block-57"
                  onClick={() => handleRemoveItem(i)}
                  key={i}
                >
                  {f.name}
                </div>
              );
            })}
          </div>
          <div
            className="div-block-60"
            style={{
              zIndex: 10,
              paddingRight: "20px",
              display: !popupOpen ? "none" : "",
            }}
          >
            <div className="div-block-61">
              <Select
                value={[fcolumn, "111"]}
                // value={filterState.column}
                onChange={(x) => {
                  setfColumn(x);
                }}
                options={columns.map((x) => x.name)}
                getOptionValue={(gene) => gene[1]}
                getOptionLabel={(gene) => (
                  <div
                    style={
                      {
                        // fontSize: 21,
                      }
                    }
                  >
                    {gene}
                  </div>
                )}
                className={"div-block-59"}
                // classNamePrefix={'dropdown-item"'}
                placeholder="Column"
              />
              <Select
                value={[foperation ? foperation : null]}
                onChange={(x) => {
                  setfoperation(x);
                }}
                options={operations?.map((x) => x.op)}
                getOptionValue={(gene) => gene}
                getOptionLabel={(gene) => (
                  <div
                    style={
                      {
                        // fontSize: 21,
                      }
                    }
                  >
                    {gene}
                  </div>
                )}
                className={"div-block-59"}
                // classNamePrefix={'dropdown-item"'}
                placeholder="Operation"
              />
            </div>
            <div className="div-block-62">
              <input
                className="div-block-59"
                style={
                  {
                    // width: '100%'
                  }
                }
                onChange={(e) => setfvalue(e.target.value)}
              />
              <div
                className="div-block-55"
                style={{
                  marginLeft: "30px",
                  marginRight: "10px",
                  padding: "10px 20px",
                }}
                onClick={() => handleAddFilter()}
              >
                Add
              </div>
            </div>
          </div>
        </div>
        <div className="div-block-59">
          <img
            src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/616fe59239550ceeca340d79_icons8-search-60.png"
            loading="lazy"
            width={27}
            alt=""
          />
          {/* <div className="text-block-21">Search Gene...</div> */}
          <Select
            value={selectGene}
            onChange={onchangeSelect}
            options={allData?.slice(0,5000).map((x) => x[1])}
            getOptionValue={(gene) => gene}
            isMulti
            getOptionLabel={(gene) => (
              <div
                style={
                  {
                    // fontSize: 21,
                  }
                }
              >
                {gene}
              </div>
            )}
            className={"text-block-21"}
            styles={{width: '60%'}}
            // classNamePrefix={'dropdown-item"'}
            placeholder="Search Gene"
          />
        </div>
        {console.log("1111")}

        <div className="div-block-58"
          style={{
            justifyContent: 'space-evenly'
          }}
        >
          <div className="div-block-55">Send To StringDb</div>
          <div className="div-block-55">Send To Enrichr</div>
        </div>
      </div>
      {filteredItems && (
        <div className="div-block-29"
        style={{  width: "100%" }}
        
        >
          <div className="div-block-52"
            style={{ display: "", width: "80%" }}
        
          >
            {console.log("www")}

            <DataTable
              style={{
                padding: "50px",
              }}
              title="Contact List"
              columns={columns}
              data={filteredItems}
              paginationPerPage={9}
              pagination
              pag
              // paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
              // subHeader
              // subHeaderComponent={subHeaderComponentMemo}
              // selectableRows
              // persistTab
            />
          </div>
          <div
            className="div-block-52"
            style={{ display: "", width: "90%" }}
          >
            {chartType === "bar" ? (
              <>
                {" "}
                <Plot
                  data={[
                    {
                      x: filteredItems.map((x) => {
                        return x[1];
                      }),
                      y: filteredItems.map((x) => {
                        return x[3];
                      }),
                      type: "bar",
                      mode: "markers",
                      // mode: "lines+markers",
                      marker: { color: "rgba(249, 120, 0, 0.8)" },
                    },
                    // { type: "bar", x: [1, 2, 3], y: [2, 5, 3] },
                  ]}
                  layout={{ width: 900, height: 640, title: "Bar Plot" }}
                  // onSelected={(x) => console.log(x)}
                />
              </>
            ) : chartType === "scatter" ? (
              <>
                <Plot
                  data={[
                    {
                      x: filteredItems.map((x) => {
                        return x[3];
                      }),
                      y: filteredItems.map((x) => {
                        return x[4];
                      }),
                      text: filteredItems.map((x) => {
                        return `${x[1]}, ${x[2]}`;
                      }), 
                      type: "scatter",
                      mode: "markers",
                      // mode: "lines+markers",
                      marker: { color: "rgba(249, 120, 0, 0.5)", width: 0.1 },
                    },
                    // { type: "bar", x: [1, 2, 3], y: [2, 5, 3] },
                  ]}
                  layout={{ width: 900, height: 640, title: "Scatter Plot", xaxis: {
                    title: {
                      text: 'Log2FC',
                      font: {
                        size: 18,
                        color: '#7f7f7f'
                      }
                    },
                  },
                  yaxis: {
                    title: {
                      text: 'Padj',
                      font: {
                        size: 15,
                        color: '#7f7f7f'
                      }
                    }
                  }, }}
                  onSelected={onScatterSelect}
                  onRelayout={(x) => {
                    console.log(x);
                    if (x?.["xaxis.autorange"]) {
                      console.log("yoo");
                      setFilteredItems(allData.slice(0, 5000));
                    }
                  }}
                />
              </>
            ) : (
              <>
                <Plot
                  data={[
                    {
                      x: ["A", "B", "C", "D", "E"],
                      y: filteredItems.map((x) => {
                        return x[1];
                      }),
                      z: [
                        [0.0, 0.0, 0.75, 0.75, 0.0],
                        [0.0, 0.0, 0.75, 0.75, 0.0],
                        [0.75, 0.75, 0.75, 0.75, 0.75],
                        [0.0, 0.0, 0.0, 0.75, 0.0],
                      ],
                      type: "heatmap",
                      mode: "markers",
                      // mode: "lines+markers",
                      marker: { color: "rgba(249, 120, 0, 0.35)", width: 1 },
                    },
                    // { type: "bar", x: [1, 2, 3], y: [2, 5, 3] },
                  ]}
                  layout={{ width: 900, height: 640, title: "Heatmap" }}
                  onSelected={(x) => console.log(x)}
                />
              </>
            )}
            <div className="div-block-63">
              <div className="div-block-55" onClick={() => setChartType("bar")}>
                Bar Plot
              </div>
              <div
                className="div-block-55 graph"
                onClick={() => setChartType("scatter")}
              >
                Scatter Plot
              </div>
              <div
                className="div-block-55 graph"
                onClick={() => setChartType("heatmap")}
              >
                Heatmap
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Visual);

{
  /* {chartType === "bar" ? (
            <Chart
              series={[
                {
                  data: filteredItems?.map((x) => x[1]),
                },
              ]}
              type="bar"
              // height={350}
              options={{
                chart: {
                  type: "bar",
                  height: 450,
                },
                plotOptions: {
                  bar: {
                    borderRadius: 4,
                    horizontal: true,
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                xaxis: {
                  categories: filteredItems?.map(
                    (x) => x[1].split("ENSG000000")[1]
                  ),
                },
              }}
            />
          ) : (
            <Chart
              series={[
                {
                  name: "Sample A",
                  // data: g,
                  data: filteredItems?.map((x, i) => {
                    return [Math.log10(x[3]), x[4]];
                  }),
                },
              ]}
              type="scatter"
              // height={350}
              options={{
                chart: {
                  height: 450,
                  type: "scatter",
                  zoom: {
                    enabled: true,
                    type: "xy",
                  },
                  animations:{
                    enabled: false,
                }
                },
                xaxis: {
                  tickAmount: 10,
                  labels: {
                    formatter: function (val) {
                      // return parseFloat(val).toFixed(1);
                      return val;
                    },
                  },
                },
                yaxis: {
                  tickAmount: 7,
                },
              }}
            />
          )} */
}
